import React from "react";
import { MessageCircle } from "lucide-react";
import { trackEvent } from "../../utils/gtag";
import { buildCarServiceWhatsAppHref } from "./whatsappConfig";
import { useCarServiceCity } from "./CarServiceCityContext";

const CarServiceWhatsAppFab = () => {
  const { selectedCity } = useCarServiceCity();
  const whatsappHref = buildCarServiceWhatsAppHref({ city: selectedCity, clickType: "fab" });
  return (
    <a
      href={whatsappHref}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => {
        trackEvent("whatsapp_clicked", { location: "fab" });
      }}
      data-testid="whatsapp-fab"
      className="fixed bottom-24 lg:bottom-6 right-5 z-40 w-14 h-14 rounded-full bg-green-600 hover:bg-green-700 shadow-[0_8px_24px_-4px_rgba(22,163,74,0.5)] hover:shadow-[0_12px_32px_-4px_rgba(22,163,74,0.6)] inline-flex items-center justify-center transition-all hover:-translate-y-1"
      aria-label="Chat with us on WhatsApp"
    >
      <MessageCircle className="h-7 w-7 text-white" strokeWidth={2.2} />
    </a>
  );
};

export default CarServiceWhatsAppFab;
